module.exports = __webpack_public_path__ + "static/media/noti-mencao.0a250c87.svg";